var REQUIRED_PROPERTIES = ['container', 'type'];
var PREFIX = '@keen.io/dataviz';
export var validateOptions = function (options) {
    REQUIRED_PROPERTIES.forEach(function (name) {
        if (!(name in options)) {
            throw new Error(PREFIX + " - " + name + " property is required");
        }
    });
    var container = options.container;
    if (!(container instanceof HTMLElement || typeof container === 'string')) {
        throw new Error(PREFIX + " - container property must be instance of HTMLElement or DOM Element selector");
    }
};
